//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";

// custom pages
import { styles } from "./styles";
import AuditAPI from "apis/audit/audit";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Fragment } from "react";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function View(props) {
  const { state, dispatch } = useContext(Context);

  const { getAuditTableConfig, updateAuditConfig } = AuditAPI();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();

  const [states, setstates] = useState({
    audittableConfig: [],
    tablesArr: [],
    tableName: "",
    columnName: "",
    create: false,
    update: false,
    delete: false,
    reason: false,
    data: {},
    edittedData: {},
    isEdit: false,
    loading: false,
  });

  const {
    audittableConfig,
    tablesArr,
    tableName,
    columnName,
    create,
    update,
    reason,
    data,
    edittedData,
    isEdit,
    loading,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      let dataObj = location?.state?.data;
      setDataObj(dataObj);
    }
  }, []);

  const setDataObj = (dataObj) => {
    setStates({
      data: dataObj,
      tableName: dataObj?.table_name,
      columnName: dataObj?.column_name,
      create: dataObj?.create,
      update: dataObj?.update,
      delete: dataObj?.delete,
      reason: dataObj?.reason,
    });
  };

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "PROMOTION", "VIEW"],
    });
  }, []);

  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

  useEffect(() => {
    handleGetAuditTableConfig();
  }, []);

  //  api func
  const handleGetAuditTableConfig = async () => {
    try {
      let res = await getAuditTableConfig();
      if (res) {
        const uniqueTablesArr = Array.from(
          new Set(res?.data?.map((a) => a.table_alias_name))
        ).map((name) => {
          return res?.data?.find((a) => a.table_alias_name === name);
        });
        setStates({ audittableConfig: res?.data, tablesArr: uniqueTablesArr });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // create api func
  const handleUpdateRule = async () => {
    try {
      if (Object.keys(edittedData).length === 0) {
        toast.error("Please alter atleast one field.", {
          toastId: "update-error",
        });
        setStates({ loading: false });
        return;
      }

      if (edittedData?.tableName && !edittedData?.columnName) {
        toast.error("Please select the column.", {
          toastId: "update-error",
        });
        setStates({ loading: false });
        return;
      }
      let values;
      values = {
        ...edittedData,
        id: data?.id,
      };
      //console.log({ values });
      let res = await updateAuditConfig(values);
      if (res?.data === 1) {
        toast.success("Updated", { toastId: "config-updated" });
        history.goBack();
      }
      setStates({ loading: false });
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>

          {!isEdit && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={()=>{
                if(state?.userInfo?.editAction){
                setStates({ isEdit: true });
                return;
              }
            else{
              toast.error(state.userInfo?.editAccess)
            return;
          }}}
            >
              Edit
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>Table Name : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Table Name"}
                  select
                  className={classes.editInput}
                  type={"text"}
                  required
                  value={tableName}
                  onChange={(e) => {
                    setStates({
                      tableName: e.target.value,
                      edittedData: {
                        ...edittedData,
                        tableName: e.target.value,
                      },
                    });
                  }}
                >
                  {tablesArr?.map((t, i) => (
                    <MenuItem value={t.table_alias_name} key={i}>
                      {t.table_alias_name}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}> {tableName}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>Column Name : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Column Name"}
                  select
                  className={classes.editInput}
                  type={"text"}
                  required
                  value={columnName}
                  onChange={(e) => {
                    setStates({
                      columnName: e.target.value,
                      edittedData: {
                        ...edittedData,
                        columnName: e.target.value,
                      },
                    });
                  }}
                >
                  {audittableConfig
                    ?.filter((a) => a.table_alias_name === tableName)
                    ?.map((t, i) => (
                      <MenuItem value={t.column_alias_name} key={i}>
                        {t.column_alias_name}
                      </MenuItem>
                    ))}
                </CssTextField>
              ) : (
                <span className={classes.label}> {columnName}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>Create : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Active"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={create}
                  onChange={(e) => {
                    setStates({
                      create: e.target.value,
                      edittedData: {
                        ...edittedData,
                        create: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}> {create?.toString()}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>Update : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Active"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={update}
                  onChange={(e) => {
                    setStates({
                      update: e.target.value,
                      edittedData: {
                        ...edittedData,
                        update: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}> {update?.toString()}</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>Delete : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Active"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={states?.delete}
                  onChange={(e) => {
                    setStates({
                      delete: e.target.value,
                      edittedData: {
                        ...edittedData,
                        delete: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}>
                  {" "}
                  {states.delete?.toString()}
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>Reason : </strong>
            </Grid>
            <Grid item xs={8}>
              {isEdit ? (
                <CssTextField
                  variant="outlined"
                  id={"Is Active"}
                  select
                  type={"text"}
                  required
                  className={classes.editInput}
                  value={reason}
                  onChange={(e) => {
                    setStates({
                      reason: e.target.value,
                      edittedData: {
                        ...edittedData,
                        reason: e.target.value,
                      },
                    });
                  }}
                >
                  {[
                    { label: "True", value: true },
                    { label: "False", value: false },
                  ].map((t, i) => (
                    <MenuItem value={t.value} key={i}>
                      {t.label}
                    </MenuItem>
                  ))}
                </CssTextField>
              ) : (
                <span className={classes.label}> {reason?.toString()}</span>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {isEdit && (
            <Fragment>
              <Button
                className={classes.cancelBtn}
                onClick={() => {
                  setDataObj(data);
                  setStates({ isEdit: false, edittedData: {} });
                }}
              >
                Cancel
              </Button>
              &nbsp; &nbsp; &nbsp;
              <Button
                className={classes.submitBtn}
                onClick={() => {
                  setStates({ loading: true });
                  handleUpdateRule();
                }}
                disabled={loading}
              >
                Update
              </Button>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
